export default __webpack_public_path__ + "static/media/Price_And_Shipping_Update_Summary_02102025.bdea419f.zip";